import { Fragment } from 'react';

import useNationalTeamFrequentFlyer from './UseNationalTeamFrequentFlyer';

import FrequentFlyerFormGrid from '../../../components/grids/frequentFlyerForm/FrequentFlyerFormGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import { LOADING_MSG } from '@usas/ui-web/utils/Constants';

const NationalTeamFrequentFlyer = () => {
  const {
    isLoading,
    personId,
    gridData,
    onSubmitFrequentFlyerForm
  } = useNationalTeamFrequentFlyer();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Frequent Flyers</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12">
          <FrequentFlyerFormGrid
            gridData={gridData}
            personId={personId}
            onSubmitFormCallback={onSubmitFrequentFlyerForm} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default NationalTeamFrequentFlyer;